import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Table } from '../../components'
import { DeviceTypeEnum } from '../../data/enums'
import { useAccessControlStore } from '../AccessControl/AccessControlStore'
import { LotContext } from './LotContext'
import {
    carpayDeviceTableColumns,
    getAccessControlDevicesByLot,
    getAccessControlDeviceTableRow,
    getLotDevicesValues
} from './utils'

export const LotCarpayDevices = () => {
    const lotContext = useContext(LotContext)
    const history = useHistory()
    const { sites, devices } = useAccessControlStore()
    const { lpBasedAc } = useFlags()

    const accessControlDevices = lpBasedAc
        ? getAccessControlDevicesByLot(sites, devices, lotContext?.selectedLot?.id)
        : []

    // const sortedStations = [...(lotContext?.lotStations?.station || [])].sort((a, b) =>
    //     a.station_name.localeCompare(b.station_name)
    // )
    const sortedStations = [...(lotContext?.lotStations?.station || [])]
        .filter((station) => station.type !== DeviceTypeEnum.SCANNER)
        .sort((a, b) => {
            const getTypeFromName = (name: string | undefined) => {
                const parts = name?.split('_')
                return parts ? parts[parts.length - 1] : ''
            }

            const typeA = a.type ?? getTypeFromName(a.station_name)
            const typeB = b.type ?? getTypeFromName(b.station_name)

            const typeComparison = typeA.localeCompare(typeB)
            if (typeComparison !== 0) {
                return typeComparison
            }

            const numberA = parseInt(a.station_name?.split('_')?.[1], 10)
            const numberB = parseInt(b.station_name?.split('_')?.[1], 10)

            const validNumberA = !isNaN(numberA)
            const validNumberB = !isNaN(numberB)

            if (validNumberA && validNumberB) {
                return numberA - numberB
            }
            if (validNumberA) return -1 // Prioritize items with a number
            if (validNumberB) return 1 // Prioritize items with a number

            // Fallback to lexicographical comparison of the full station name
            return (a.station_name ?? '').localeCompare(b.station_name ?? '')
        })

    const carpayData = sortedStations.map((station) =>
        getLotDevicesValues(station, () => {
            lotContext.setEditingStation(station)
        })
    )

    const acData = accessControlDevices.map((acDevice) => getAccessControlDeviceTableRow(acDevice, history))

    const convertedData = [...carpayData, ...acData]
    if (!lotContext.selectedLot) {
        return null
    }
    return (
        <div>
            <Table columns={carpayDeviceTableColumns} data={convertedData} />
        </div>
    )
}
